/**
 * Timezone utilities for consistent date formatting across the app
 */

// Get the user's detected timezone
export const getUserTimezone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

// Format a date string to the user's locale with their timezone
export const formatDateWithTimezone = (
  dateString: string,
  options: Intl.DateTimeFormatOptions = {}
): string => {
  const date = new Date(dateString);
  const timezone = getUserTimezone();
  
  return date.toLocaleString(undefined, {
    timeZone: timezone,
    ...options,
  });
};

// Format a timestamp (time only) with timezone
export const formatTimeWithTimezone = (dateString: string): string => {
  return formatDateWithTimezone(dateString, {
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Format a full date with time and timezone
export const formatFullDateWithTimezone = (dateString: string): string => {
  return formatDateWithTimezone(dateString, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Format a short date (for message grouping)
export const formatShortDateWithTimezone = (dateString: string): string => {
  return formatDateWithTimezone(dateString, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Get just the date portion for grouping messages by day
export const getDateKeyWithTimezone = (dateString: string): string => {
  const date = new Date(dateString);
  const timezone = getUserTimezone();
  
  return date.toLocaleDateString(undefined, {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};
